export class TipoDeBem {
  cD_BPM_CLASSE_TIPO_BEM!: number;	
  
  cD_BPM_AT1_TIPO_BEM!: number;	
  
  cD_BPM_TUC_TIPO_BEM!: number;	
  
  nR_BPM_TIPO_BEM_PATRIMONIAL!: number;	

  dS_BPM_DESCRICAO_TIPO_BEM!: string
  
  dS_BPM_DENOMINACAO_CLASSE_TIPO_BEM!: string
  
  fL_BPM_ATIVO!: number;	
  
  fL_BPM_DELETADO!: number;	

  vL_BPM_ALIQUOTA_DEPRECIACAO:number;
  
}
